
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/outlet/electrical-store",
      function () {
        return require("private-next-pages/outlet/electrical-store.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/outlet/electrical-store"])
      });
    }
  